var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',_vm._b({on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},'a-modal',_vm.options,false),[_c('div',{staticClass:"modal-content-wrap"},[_vm._v(" "+_vm._s(_vm.options.contentTips)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }